(() => {
  const lang = () => document.documentElement.getAttribute('data-tava-lang') || document.documentElement.lang || 'ar';
  const copy = {
    sending: { ar: 'جارٍ إرسال طلبك…', en: 'Sending your order…' },
    missing: { ar: 'يرجى تعبئة الاسم والهاتف والمدينة.', en: 'Please fill in your name, phone, and city.' },
    empty: { ar: 'سلتك فارغة. أضف منتجات قبل إتمام الطلب.', en: 'Your cart is empty. Add products before checking out.' },
    error: { ar: 'تعذّر إرسال الطلب. حاول مرة أخرى.', en: 'Could not send the order. Please try again.' },
    thanks: { ar: 'تم استلام طلبك. سنتواصل معك لتأكيد التوصيل.', en: 'Your order was received. We will contact you to confirm delivery.' },
  };

  function t(key) {
    const entry = copy[key];
    return (entry && (entry[lang()] || entry.ar)) || '';
  }

  function setStatus(el, message, kind) {
    if (!el) return;
    el.hidden = !message;
    el.textContent = message || '';
    el.dataset.kind = kind || '';
  }

  function customerFields(form) {
    return {
      name: (form.customer_name.value || '').trim(),
      phone: (form.customer_phone.value || '').trim(),
      city: (form.customer_city.value || '').trim(),
      address: (form.customer_address.value || '').trim(),
    };
  }

  function noteFromFields(fields) {
    return [fields.name, fields.phone, fields.city, fields.address].filter(Boolean).join(' · ');
  }

  function cartAttributes(fields) {
    return {
      'Cash on delivery': 'Yes',
      Name: fields.name,
      Phone: fields.phone,
      City: fields.city,
      Address: fields.address || '',
    };
  }

  function localItems() {
    return window.tavaCart?.read?.() || [];
  }

  async function addProductToCart(variantId, quantity = 1) {
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity,
      }),
    });

    if (!addRes.ok) {
      let message = '';
      try {
        const data = await addRes.json();
        message = data.description || data.message || '';
      } catch (e) {
        message = '';
      }
      const err = new Error(message);
      err.status = addRes.status;
      throw err;
    }
  }

  async function updateCartCheckout(fields) {
    const updateRes = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        note: noteFromFields(fields),
        attributes: cartAttributes(fields),
      }),
    });

    if (!updateRes.ok) {
      const err = new Error(t('error'));
      err.status = updateRes.status;
      throw err;
    }
  }

  async function readShopifyCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(t('error'));
    return res.json();
  }

  async function collectItems(root, mode) {
    const items = [];

    if (mode === 'product' && root.dataset.variantId) {
      items.push({ id: root.dataset.variantId, variantId: root.dataset.variantId, quantity: 1 });
    }

    try {
      const cart = await readShopifyCart();
      (cart.items || []).forEach((line) => {
        items.push({ id: line.variant_id, variantId: line.variant_id, quantity: line.quantity });
      });
    } catch (e) {
      /* ignore */
    }

    localItems().forEach((item) => {
      if (!items.some((row) => String(row.variantId) === String(item.id))) {
        items.push({ id: item.id, variantId: item.id, quantity: item.quantity, title: item.title });
      }
    });

    return items;
  }

  async function syncLocalIntoShopify(items) {
    let added = 0;
    for (const item of items) {
      try {
        await addProductToCart(item.variantId || item.id, item.quantity || 1);
        added += 1;
      } catch (e) {
        /* sold out on Shopify — keep going */
      }
    }
    return added;
  }

  async function submitDraftOrder(fields, items) {
    const res = await fetch('https://us-central1-tava-5055c.cloudfunctions.net/submitCodOrder', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        name: fields.name,
        phone: fields.phone,
        city: fields.city,
        address: fields.address,
        items,
      }),
    });

    let data = {};
    try {
      data = await res.json();
    } catch (e) {
      data = {};
    }

    if (!res.ok || !data.ok) {
      const err = new Error(data.error || t('error'));
      err.status = res.status;
      throw err;
    }

    return data;
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-tava-cod-form]');
    if (!form) return;

    const root = form.closest('[data-tava-cod]');
    if (!root) return;

    event.preventDefault();

    const status = root.querySelector('[data-tava-cod-status]');
    const submit = form.querySelector('[type="submit"]');
    const fields = customerFields(form);
    const mode = root.dataset.tavaCodMode || 'product';

    if (!fields.name || !fields.phone || !fields.city) {
      setStatus(status, t('missing'), 'error');
      return;
    }

    if (submit) submit.disabled = true;
    setStatus(status, t('sending'), 'info');

    try {
      const items = await collectItems(root, mode);
      if (!items.length) {
        const err = new Error(t('empty'));
        err.code = 'empty';
        throw err;
      }

      const added = await syncLocalIntoShopify(items);
      const cart = await readShopifyCart();

      if (added > 0 || cart.item_count > 0) {
        await updateCartCheckout(fields);
        window.tavaCart?.clear?.();
        window.location.href = root.dataset.checkoutUrl || '/checkout';
        return;
      }

      await submitDraftOrder(fields, items);
      window.tavaCart?.clear?.();
      setStatus(status, t('thanks'), 'info');
      window.setTimeout(() => {
        window.location.href = '/';
      }, 1600);
    } catch (err) {
      setStatus(status, err.code === 'empty' ? t('empty') : err.message || t('error'), 'error');
      if (submit) submit.disabled = false;
    }
  });
})();
